/* eslint-disable */
import React, { useCallback, useEffect, useState } from "react";
import moment from "moment";
import { makeStyles } from "@material-ui/core";
import { useSelector, useDispatch } from "react-redux";

import PassRevenueList from "./passRevenueList";
import PassRevenueModal from "./passRevenueModal";
import { PageWrapper } from "../../../../shared/layout";
import { MessageType, NEW_BASE_URL } from "../../../../Constant";
import {
  Button, ExportButton, BarLoader, RangePicker,
} from "../../../../shared/widgets";
import { saveExcelBlob } from "../../../../shared/methods/sharedMethods";
import { newReconDownloadExcelAPI } from "../../../../services/APIutils";
import { selectDateFilter } from "../../../../redux/actions/dateFilterAction";
import UploadExcelModal from "../../../../shared/components/fileupload/UploadExcelModal";
import { updateRefreshUpliftStatus } from "../../../../redux/actions/contractedVehicleAction";
import { fetchPassRevenueCities } from "../../../../redux/action-creators/passRevenueActionCreator";

const useStyles = makeStyles((theme) => ({
  headerItem: {
    margin: "0 1vh",
  },
  "@media (max-width:576px)": {
    customPageWrapper: {
      "& .page-header": {
        flexWrap: "wrap",
        paddingLeft: 0,
        "& .page-header-title": {
          fontSize: "25px",
        },
      },
    },
    headerItem: {
      margin: "1vh 1vh 0 0",
      "& .DateRangePicker": {
        marginLeft: "0",
      },
    },
    headerWrapper: {
      width: "100%",
      flexWrap: "wrap",
    },
  },
}));

function PassRevenueView(props) {
  const classes = useStyles();
  const dispatch = useDispatch();

  const selectedDateFilter = useSelector(
    (state) => state.DateFilter.selectedDateFilter,
  );
  const cityFilter = useSelector((state) => state.Cities.selectedCity);
  const operatorFilter = useSelector(
    (state) => state.Operators.selectedOperator,
  );
  const [openUploadXlsxModal, setOpenUploadXlsxModal] = useState(false);
  const [open, setOpen] = useState(false);
  const [refresh, setRefresh] = useState(false);
  useEffect(() => {
    dispatch(fetchPassRevenueCities());
  }, []);

  const endpoint = "reconReports/exportManualPassRevenueDetails";
  const exportPassRevenueQuery = {
    platform: "web",
    timezoneOffset: -330,
    cityIdArr: cityFilter || [],
    operatorIdArr: operatorFilter || [],
    fromDate: selectedDateFilter?.fromDate || "",
    toDate: selectedDateFilter?.toDate || "",
    pageNo: 0,
    pageSize: 20,
  };

  const viewUploadXlsxModal = useCallback(() => {
    setOpenUploadXlsxModal(true);
  }, []);

  const displayUploadXlsxModal = () => (
    <UploadExcelModal
      showModal={openUploadXlsxModal}
      isUploadDisabled={false}
      messageCallBack={(type, msg) => {
        // if (type === MessageType.SUCCESS) {
        //   this.getSettlementDistanceStatus();
        // }
        if (
          type === MessageType.SUCCESS
            || !(type && type === MessageType.ERROR)
        ) {
          setOpenUploadXlsxModal(false);
        }
      }}
      uploadType="passRevenue"
    />
  );

  const handleDatesChange = (dates) => {
    if (dates.startDate && dates.endDate) {
      const fromDate = parseFloat(new Date(dates.startDate).getTime());
      const toDate = parseFloat(new Date(dates.endDate).getTime());
      dispatch(selectDateFilter({ fromDate, toDate }));
    }
  };

  const downloadSampleExcel = async () => {
    const url = `${NEW_BASE_URL}/v1/reconReports/samplePassRevenueUploadSheet`;
    await newReconDownloadExcelAPI(url, {})
      .then((res) => {
        let fileName = res.headers["content-disposition"].split("Filename=")[1];
        fileName = fileName.replaceAll("\"", "");
        saveExcelBlob({ blob: res.data, fileName });
      })
      .catch((err) => {
        console.log("Error Occured, ", err.message);
        props.initiateNotification({
          type: MessageType.ERROR,
          message: err.message,
        });
      });
  };

  const toggleModal = useCallback(() => {
    setOpen(!open);
  }, [open]);

  return (
    <div className="pageContainer">
      <PageWrapper customClass={classes.customPageWrapper}>
        <PageWrapper.Header heading="Pass Revenue" hideS>
          <div className={`flex pull-right ${classes.headerWrapper} `}>
            <div className={classes.headerItem}>
              <RangePicker
                startDate={moment(new Date(selectedDateFilter?.fromDate))}
                endDate={moment(new Date(selectedDateFilter?.toDate))}
                monthsToDisplay={1}
                onDatesChange={handleDatesChange}
              />
            </div>
            <div className={classes.headerItem}>
              <ExportButton
                query={exportPassRevenueQuery}
                endpoint={endpoint}
                pageName="Pass Revenue"
                isDisable={updateRefreshUpliftStatus == "Data Sync In Process"}
              />
            </div>
            <div
              className="xlsx-wrapper cursor-pointer"
              onClick={downloadSampleExcel}
              onKeyDown={
                (event) => {
                  event.key === "Enter" && downloadSampleExcel()
                }
              }
            >
              Sample File
            </div>
            <div className={classes.headerItem}>
              <Button onClick={viewUploadXlsxModal} buttonText="Upload" />
            </div>
            <Button onClick={toggleModal} buttonText="New Pass Revenue" />
          </div>
        </PageWrapper.Header>
        <PageWrapper.Body>
          <BarLoader scope="header" />
          <PassRevenueList
            refresh={refresh}
            setRefresh={setRefresh}
            selectedDateFilter={{
              fromDate: moment(selectedDateFilter.fromDate)
                .format("YYYY-MM-DD")
                .toString(),
              toDate: moment(selectedDateFilter.toDate)
                .format("YYYY-MM-DD")
                .toString(),
            }}
          />
          {open && (
            <PassRevenueModal
              open={open}
              setOpen={setOpen}
              setRefresh={setRefresh}
            />
          )}
          {openUploadXlsxModal && displayUploadXlsxModal()}
        </PageWrapper.Body>
      </PageWrapper>
    </div>
  );
}

export default PassRevenueView;
